import Component from '@glimmer/component';
import { action } from '@ember/object';
import { on } from '@ember/modifier';
import { faArrowDown, faArrowUp } from '../icons/solid.js';
import Icon from './icon.gjs';

export default class Sortable extends Component {
  get sortAscending() {
    return this.args.value === `${this.args.name}:asc`;
  }

  get sortDescending() {
    return this.args.value === `${this.args.name}:desc`;
  }

  @action
  toggle(event) {
    const { name, value, onChange } = this.args;
    if (
      !onChange ||
      (event instanceof KeyboardEvent &&
        event.key !== 'Enter' &&
        event.key !== ' ')
    ) {
      return;
    }

    onChange(
      !value.startsWith(name) || value.endsWith('desc')
        ? `${name}:asc`
        : `${name}:desc`,
    );
  }

  <template>
    <button
      role="button"
      tabindex="0"
      class="flex items-center space-x-1 cursor-pointer"
      {{on "click" this.toggle}}
      {{on "keydown" this.toggle}}
    >
      <div>{{yield}}</div>

      {{#if this.sortAscending}}
        <Icon @icon={{faArrowDown}} @size="1x" />
      {{else if this.sortDescending}}
        <Icon @icon={{faArrowUp}} @size="1x" />
      {{else}}
        <div class="opacity-0">
          <Icon @icon={{faArrowDown}} @size="1x" />
        </div>
      {{/if}}
    </button>

    <style>
      button:hover,
      button:focus {
        .opacity-0 {
          opacity: 0.6;
        }
      }
    </style>
  </template>
}

